import React from 'react'
import {useQuery} from '@apollo/client'
import {RouteComponentProps} from '@reach/router'

import Page from './layout/Page'
import {Loader} from './layout'
import CollectionSlider from './Collection/CollectionSlider'
import {collectionsQuery} from './Collection/collection-queries'
import {Collections, CollectionsVariables} from './Collection/_gql-types/Collections'
import {CollectionPublished} from '../_gql-types/global'
import CollectionBanner from './Collection/CollectionBanner'


export default function Home(_: RouteComponentProps) {
  const {data, loading} = useQuery<Collections, CollectionsVariables>(
    collectionsQuery,
    {variables: {
      first: 10,
      filter: {
        published: CollectionPublished.PUBLISHED,
      },
    }},
  )

  return (
    <Page>
      {loading ? (
        <Loader />
      ) : (
        <>
          <CollectionBanner collections={data?.collections} />

          <div className="container pb-5">
            {data?.collections?.edges.map(collection => (
              <div key={collection.node.id} className="pt-5">
                <CollectionSlider collection={collection} />
              </div>
            ))}
          </div>
        </>
      )}
    </Page>
  )
}
